export default __webpack_public_path__ + "static/media/Rabar_023.df184149.ttf";